import { Link, useLocation } from 'react-router-dom';

import { Empty, PageHead } from '../components/ui';
import { useDocumentTitle } from '../lib/hooks';

export function NotFound() {
  useDocumentTitle('Not found');
  const { pathname } = useLocation();
  return (
    <>
      <PageHead title="Nothing here" />
      <Empty title="This page isn’t in the console">
        <p>
          <code>{pathname}</code> doesn’t match a page. It may have moved, or the link has a typo.
        </p>
        <div className="row mt-8">
          <Link className="btn btn--primary" to="/">
            Go to Sandboxes
          </Link>
          <Link className="btn" to="/docs">
            Read the docs
          </Link>
        </div>
      </Empty>
    </>
  );
}
